export default __webpack_public_path__ + "static/media/06_02.90dc79a1.jpg";